import { create } from 'zustand'

/**
 * 首次注册前的邀请码确认。
 *
 * 钱包地址一旦签名连接就会直接建号并**永久绑定推荐人**，事后无法自助更换。
 * 所以在签名之前先把邀请码摆到用户面前确认一次，避免拿错邀请链接（或用了
 * 上一次残留在 localStorage 里的旧邀请码）就把关系绑死。
 *
 * 做成全局 store 而不是组件内 state：登录可能从 Header 或页面内任一处触发，
 * 而弹窗只在 App 根渲染一份，两者需要跨组件对上。
 */
interface PendingConfirm {
  /** 当前待确认的邀请码（来自 URL ?ref= 或 localStorage），可能为空 */
  inviteCode: string
  /** 后台开关：关闭时允许无邀请码直接注册（注册后为顶级账号，无推荐人） */
  inviteCodeRequired: boolean
  /** 用户确认返回最终邀请码，取消返回 null */
  resolve: (code: string | null) => void
}

interface RegisterConfirmState {
  pending: PendingConfirm | null
  /** 发起一次确认，返回用户最终选定的邀请码；取消则为 null */
  request: (params: { inviteCode: string; inviteCodeRequired: boolean }) => Promise<string | null>
  confirm: (code: string) => void
  cancel: () => void
}

export const useRegisterConfirmStore = create<RegisterConfirmState>((set, get) => ({
  pending: null,

  request: ({ inviteCode, inviteCodeRequired }) =>
    new Promise<string | null>((resolve) => {
      set({ pending: { inviteCode, inviteCodeRequired, resolve } })
    }),

  confirm: (code) => {
    const { pending } = get()
    set({ pending: null })
    pending?.resolve(code)
  },

  cancel: () => {
    const { pending } = get()
    set({ pending: null })
    pending?.resolve(null)
  },
}))
